import { Card } from 'antd';
import './UrlClusters.less';
import React, { useMemo } from 'react';
import { useFetchUrlClustersQuery } from './service';
import { useNavigate, useLocation } from "react-router-dom";
import UrlClusterDetails from './UrlClusterDetails';
import useBatchUrlAnalysisProcessesPolling from '../process/hooks/useBatchUrlAnalysisProcessesPolling';
import { DPA_DASHBOARD_POLLING_TIME_MS } from '../settings';
import CardTitleWithProgressIndicator from '../shared/CardTitleWithProgressIndicator';


type Props = {
    websiteGuid: string;
};


export default function UrlClustersList({ websiteGuid }: Props) {
    const navigate = useNavigate();
    const location = useLocation();

    const { isRunningBatchAnalysis, isLoadingRunningProcesses } = useBatchUrlAnalysisProcessesPolling(websiteGuid);
    const { data: clusters, isLoading: isLoadingUrlClusters } = useFetchUrlClustersQuery(
        { w_guid: websiteGuid },
        {
            // The polling interval is in milliseconds!
            pollingInterval: isRunningBatchAnalysis ? DPA_DASHBOARD_POLLING_TIME_MS : 0,
            // refetchOnMount can take a number that will refetch if the cache value is older than the value
            // This is in seconds!
            refetchOnMountOrArgChange: isRunningBatchAnalysis ? DPA_DASHBOARD_POLLING_TIME_MS / 1000 : false,
        }
    );
    const isLoading = isLoadingUrlClusters || isLoadingRunningProcesses;
    const filteredClusters = useMemo(() => clusters?.filter((cluster) => cluster.monitored_urls > 0), [clusters]);

    const handleViewUrlsClick = (clusterGuid: string) => {
        const params = new URLSearchParams(location.search);
        params.set('cluster_guid', clusterGuid);
        navigate(`/deep-analysis/page-group?${params.toString()}`);
    };

    return (
        <Card
            loading={isLoading}
            title={<CardTitleWithProgressIndicator title="Page Groups" description="SEO audit in progress" isInProgress={isRunningBatchAnalysis} />}
        >
            <div className="page-groups-container">
                {filteredClusters &&
                    filteredClusters.map((cluster) => (
                        <UrlClusterDetails
                            key={cluster.guid}
                            websiteGuid={websiteGuid}
                            cluster={cluster}
                            shouldLongPollFailedChecks={isRunningBatchAnalysis}
                            onViewUrlsClicked={() => handleViewUrlsClick(cluster.guid)}
                        />
                    ))}
            </div>
        </Card>
    );
}
